import * as React from 'react';

import AlertBubble16 from './AlertBubble16';

export const alertBubble16 = () => <AlertBubble16 />;

export default {
    title: 'Icon/Line/AlertBubble16',
    component: AlertBubble16,
    parameters: {
        notes: "`import AlertBubble16 from 'box-ui-elements/es/icon/line/AlertBubble16';`",
    },
};
